import { render } from "./NewClientAttributeMaster.vue?vue&type=template&id=7efd7e40"
import script from "./NewClientAttributeMaster.vue?vue&type=script&lang=js"
export * from "./NewClientAttributeMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__